import { TextField } from "@mui/material";
import { ImperialDistance } from "../../misc/ImperialDistance";
import { genericDistanceParser } from "../../misc/scroller/Table";
import { useProjectUnitSystem } from "../project/shopdrawing/ProjectName";
import { MetricDistance } from "../../misc/MetricDistance";
import { jsx as _jsx } from "react/jsx-runtime";
export function DimensionInput2(props) { const units = useProjectUnitSystem(); return /*#__PURE__*/ _jsx(TextField, { fullWidth: true, label: props.label, InputLabelProps: { shrink: true }, size: "small", variant: "outlined", disabled: props.disabled, value: props.value, placeholder: props.blankPlaceholder, onBlur: e => { try {
        if (props.inches) {
            props.onChange(ImperialDistance.parse(e.target.value).toInchesString());
            return;
        }
        let v;
        if (units === "metric") {
            v = MetricDistance.parse(e.target.value);
        }
        else if (units === "imperial") {
            v = ImperialDistance.parse(e.target.value);
        }
        else {
            v = genericDistanceParser(e.target.value);
        }
        props.onChange(v.toString());
    }
    catch (e) { } }, onChange: e => props.onChange(e.target.value) }); }
